document.addEventListener("change", async function (event) {
  const checkbox = event.target.closest(".cart-drawer__gift-box-checkbox");

  if (!checkbox || checkbox.disabled) return;

  const option = checkbox.closest("[data-gift-box-option]");
  const errorMessage = option.querySelector(".cart-drawer__gift-box-error");
  const variantId = checkbox.dataset.variantId;
  const lineKey = checkbox.dataset.lineKey;
  const isAdding = checkbox.checked;
  const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";

  if (!variantId || (!isAdding && !lineKey)) {
    checkbox.checked = !isAdding;
    return;
  }

  checkbox.disabled = true;
  option.setAttribute("aria-busy", "true");
  errorMessage.hidden = true;

  try {
    const endpoint = isAdding ? "cart/add.js" : "cart/change.js";
    const payload = isAdding
      ? { items: [{ id: Number(variantId), quantity: 1 }] }
      : { id: lineKey, quantity: 0 };
    const response = await fetch(`${root}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) throw new Error("Gift box cart update failed");

    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  } catch (error) {
    checkbox.checked = !isAdding;
    errorMessage.hidden = false;
  } finally {
    checkbox.disabled = false;
    option.removeAttribute("aria-busy");
  }
});
